import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 34,
	height: 31,
	viewBox: "0 0 13 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.293 6.13953H10.6047V4.59535C10.6047 2.06512 8.55816 0 6.04652 0C3.53487 0 1.48838 2.06512 1.48838 4.59535V6.13953H1.06048C0.539534 6.13953 0 6.54884 0 7.06975V15.0697C0 15.5907 0.539534 16 1.06048 16H11.293C11.814 16 12.093 15.5907 12.093 15.0697V7.06978C12.093 6.54884 11.7954 6.13953 11.293 6.13953ZM6.51163 12.2791C6.51163 12.5954 6.26976 12.8372 5.9535 12.8372C5.63725 12.8372 5.39538 12.5953 5.39538 12.2791V10.9768C5.39538 10.6605 5.63725 10.4186 5.9535 10.4186C6.26976 10.4186 6.51163 10.6605 6.51163 10.9768V12.2791ZM9.48838 6.13953H2.60466V4.59535C2.60466 2.67908 4.14883 1.11628 6.04652 1.11628C7.9442 1.11628 9.48838 2.67908 9.48838 4.59535V6.13953Z",
		fill: "#999999"
	})
});
export default SvgLock;
